<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ isEdit ? "Editar" : "Agregar nuevo" }} usuario</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="[hide(), resetForm()];"
        />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2">
          <!-- Titulo -->
          <validation-provider
            #default="{ errors }"
            name="role"
            rules="requeridoE"
          >
            <b-form-group label="Tipo de Usuario" label-for="role">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="roles"
                label="name"
                v-model="items.role"
                :reduce="(role) => role.id"
                input-id="role"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="tipoLocal"
          >
            <b-form-group
              label="Tipo de Local"
              label-for="tipoLocal"
              v-if="items.role && items.role !== 1"
            >
              <v-select
                :options="tipoLocal"
                label="text"
                :reduce="(tipoLocal) => tipoLocal.id"
                input-id="tipoLocal"
                v-model="typeLocal"
                @input="filterLocal"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="local"
            rules="requeridoE"
          >
            <b-form-group label="Local" label-for="local">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                input-id="local"
                multiple
                v-model="items.stores"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="establishmentDefault"
            rules="requeridoE"
          >
            <b-form-group
              label="Establecimiento Predeterminado"
              label-for="establishmentDefault"
            >
              <v-select
                :options="items.stores"
                label="name"
                v-model="items.establishmentDefault"
                input-id="establishmentDefault"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="fullname"
            rules="requeridoE"
          >
            <b-form-group label="Completo" label-for="fullname">
              <b-form-input
                id="fullname"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Nombre Completo"
                v-model="items.fullname"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="document"
            rules="requeridoE"
          >
            <b-form-group label="Documento" label-for="document">
              <b-form-input
                id="document"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Documento"
                v-model="items.document"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="email"
            rules="requeridoE"
          >
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Email"
                v-model="items.email"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group v-if="!isEdit">
            <div class="d-flex justify-content-between">
              <label for="user-password">Contraseña</label>
            </div>
            <validation-provider
              #default="{ errors }"
              name="Password"
              vid="password"
              rules="requeridoE"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="user-password"
                  v-model="items.password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="user-password"
                  placeholder="Password"
                  autocomplete="off"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <validation-provider #default="{ errors }" name="extraPassword">
            <b-form-group label="Contraseña Extra" label-for="extraPassword">
              <b-input-group>
                <b-form-input
                  id="extraPassword"
                  readonly
                  v-model="items.extraPassword"
                  placeholder="Contraseña Aleatoria"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-secondary"
                    @click="generateExtraPassword"
                  >
                    <feather-icon icon="RefreshCwIcon" size="16" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <!-- <b-button variant="danger" @click.prevent="changeMenuList">probar</b-button> -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              @click.prevent="onSubmit(items)"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? "Actualizar" : "Agregar" }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()];"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import UserService from "@/services/UserService";
import RolesService from "@/services/RolesService";
import StoreService from "@/services/StoresService";
import vSelect from "vue-select";
Vue.use(BootstrapVue);
export default {
  directives: {
    Ripple,
  },
  components: {
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    vSelect,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      required,
      value: [],
      usedExtraPasswords: [],
      isEdit: false,
      isDisabled: false,
      roles: [],
      tipoLocal: [
        {
          id: 1,
          text: "Tienda",
          name: "STORE",
        },
        {
          id: 2,
          text: "Almacen",
          name: "WAREHOUSE",
        },
      ],
      items: {
        role: null,
        fullname: "",
        email: "",
        password: "",
        stores: [],
        document: "",
        establishmentDefault: null,
        extraPassword: "",
        //menus: []
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      },
      typeLocal: null,
      locals: [],
      arrayFilters: [],
      //menus: [],
      //menusTemp: [],
      tempLocals: [],
      temp: {},
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {
    this.getData();
    if (!this.isEdit) {
      this.generateExtraPassword();
    }
  },
  watch: {
    "items.role"(newVal) {
      if (newVal) {
        this.filterLocal();
      }
    },
  },
  methods: {
    resetForm() {
      this.$refs.refFormObserver.reset();
      this.isEdit = false;
      this.typeLocal = null;
      this.items = {
        role: null,
        fullname: "",
        email: "",
        password: "",
        stores: [],
        document: "",
        establishmentDefault: null,
        extraPassword: "",
        //menus: []
      };
    },
    getDisplayTypeLocal(typeLocal) {
      if (typeLocal === "WAREHOUSE") {
        return "Establecimiento";
      } else if (typeLocal === "STORE") {
        return "Tienda";
      }
    },
    async generateExtraPassword() {
      this.usedExtraPasswords = [];
      const resp = await UserService.getUsers("", this.$store);
      if (resp && resp.data && resp.data.rows) {
        this.usedExtraPasswords = resp.data.rows
          .map((user) => user.extraPassword)
          .filter((pwd) => pwd !== null);
      }

      let newPassword;
      do {
        newPassword = Math.floor(10000 + Math.random() * 90000).toString();
      } while (this.usedExtraPasswords.includes(newPassword));

      this.items.extraPassword = newPassword;
    },

    async setData(items) {
  console.log("items recibidos en setData:", items);

  if (Object.entries(items).length !== 0) {
    this.isEdit = true;
    this.items.id = items.id;
    this.items.role = items.roleId;
    this.items.fullname = items.fullname;
    this.items.email = items.email;
    this.items.document = items.document;
    this.items.extraPassword = items.extraPassword;

    if (items.roleId != 1) {
      const typeLocalName =
        items.establishmentDefault?.establishmentType ||
        items.stores?.[0]?.establishmentType ||
        null;

      const selected = this.tipoLocal.find(t => t.name === typeLocalName);
      this.typeLocal = selected ? selected.id : null;

      await this.filterLocal();
    } else {
      const url = `?limit=1000&page=1&order=asc&sort=id`;
      const resp = await StoreService.getStores(url, this.$store);
      this.locals = resp?.data?.rows || [];
    }

    this.items.stores = this.locals.filter(store =>
      items.establishmentsIds?.includes(store.id)
    );

    this.items.establishmentDefault = this.items.stores.find(
      store => store.id === items.establishmentDefault?.id
    ) || null;

    console.log("items cargados en edición:", this.items);
  } else {
    this.isEdit = false;
    this.resetForm();
    this.generateExtraPassword();
    console.log("this.items vacío para nuevo usuario:", this.items);
  }
},


    async getData() {
      this.showLoading = true;
      await new Promise((r) => setTimeout(r, 500));
      let dataUser = JSON.parse(localStorage.getItem("userData"));
      console.log("el acces", dataUser);
      const rolesResp = await RolesService.getRoles("", this.$store);
      if (rolesResp && rolesResp.data && rolesResp.data.rows) {
        this.roles = rolesResp.data.rows;
      }
      this.showLoading = false;
    },
    async filterLocal() {
      this.items.stores = [];
      this.items.establishmentDefault = null;

      this.arrayFilters = [];
      if (this.items.role === 1) {
        const url = `?limit=1000&page=1&order=asc&sort=id`;
        const resp = await StoreService.getStores(url, this.$store);
        if (resp) {
          this.locals = resp.data.rows;
        }
        return;
      }

      const selectedTypeLocal = this.tipoLocal.find(
        (local) => local.id === this.typeLocal
      );
      if (selectedTypeLocal && selectedTypeLocal.name) {
        this.arrayFilters.push({
          keyContains: "establishmentType",
          key: "equals",
          value: selectedTypeLocal.name,
        });
      }

      const url = `?limit=1000&page=1&order=asc&sort=id&filter=${JSON.stringify(
        this.arrayFilters
      )}`;
      const resp = await StoreService.getStores(url, this.$store);
      if (resp) {
        this.locals = resp.data.rows;
      }
    },

    async onSubmit(data) {
      console.log("data", this.items);
      console.log('typeof establishmentDefault:', typeof this.items.establishmentDefault)
      console.log('establishmentDefault object?', this.items.stores.find(s => s.id === this.items.establishmentDefault))

      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          let datos = {};
          datos.roleId = data.role;
          datos.fullname = data.fullname;
          datos.email = data.email;
          datos.password = data.password;
          datos.document = data.document;
          datos.extraPassword = data.extraPassword;
          datos.establishmentsIds = data.stores.map((store) => store.id);
          datos.establishmentDefault = data.establishmentDefault.id || null;
          this.isDisabled = true;
          let resp = "";
          console.log("datos", datos);
          if (this.isEdit == false) {
            resp = await UserService.saveUser(datos, this.$store);
          } else {
            resp = await UserService.updateUser(this.items.id, datos, this.$store);
            console.log("datos actualizados", resp);
            if (resp.error == false) {
              console.log("Actualización exitosa");
            } else {
              console.error("Error al actualizar el usuario:", resp);
            }
          }
          if (resp) {
            this.$swal({
              title: "Añadido",
              text:
                "El usuario ha sido " +
                (this.isEdit == true ? "actualizado." : "registrado."),
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
            console.log("this.$parent.$parent", this.$parent.$parent);
            this.$parent.$parent.$parent.getData();
            this.$emit("update:is-add", false);
            this.resetForm();
          } else {
            this.$swal({
              title: "Error!",
              text:
                " Hubo un error al " +
                (this.isEdit == true ? "actualizar" : "registrar") +
                " el usuario",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
          this.isDisabled = false;
        } else {
          console.log("no validado");
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
